import { useState, useEffect } from 'react';

/**
 * Fetches the top popular search terms for the chips/cards UI once on mount
 * (untyped - no query, unlike useSearchSuggestions). The server returns an
 * empty list when featureFlags.popularSearchChips.ui is off, so callers should
 * fall back to a static list rather than render nothing.
 *
 * @returns {string[]} terms - up to the server's configured top-N, most popular first
 */
export function usePopularSearches() {
  const [terms, setTerms] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();

    fetch('/api/search/popular', { signal: abortController.signal })
      .then((res) => res.json())
      .then((data) => {
        setTerms(Array.isArray(data?.terms) ? data.terms : []);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('Popular searches fetch failed:', error);
        setTerms([]);
      });

    return () => abortController.abort();
  }, []);

  return terms;
}
